/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypeTableIcon20Light = forwardRef('FileTypeTableIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V7.378a1.5 1.5 0 0 0-.44-1.06l-3.877-3.879A1.5 1.5 0 0 0 10.622 2H7Zm0 1a2 2 0 0 0-2 2v2h2V3Zm1 0v4h6.83l-3.854-3.854A.5.5 0 0 0 10.622 3H8ZM7 8H5v7a2 2 0 0 0 2 2V8Zm1 9V8h7v7a2 2 0 0 1-2 2H8Z" })));
});
